export default (props, context) => {
	const { globalVariableWithURL = [], formData = [] } = context;
	const {
		leftContent = [],
		formDetails = [],
		hasDarkBackground = false,
		topBackgroundColor = {},
		bottomBackgroundColor = {},
		itemsOnFirstColumn = "0",
		matchStyleToIframeForm = false,
	} = props;
	const isFullWidthForm = leftContent.length > 0 ? false : true;
	const content = {};
	if (!isFullWidthForm) {
		content.headline = leftContent[0].headline;
		content.subcopy = leftContent[0].subcopy;
		content.image = {
			url: leftContent[0].image?.image,
			alt: leftContent[0].image?.altTag,
		};
		const {
			labelText = "",
			brandLogos = [],
			maxLogosInRow = 0,
		} = leftContent[0].logoBar?.[0] || {};
		content.logos = leftContent[0].logoBar?.[0]
			? { labelText, brandLogos, maxLogosInRow }
			: null;
	}
	context.full_slug = context?.context?.full_slug;
	context.slug = context?.context?.slug;
	context.globalHostName = process.env.GATSBY_SITE_META_URL;
	return {
		...props,
		content,
		formDetails: formDetails[0] || null,
		isFullWidthForm,
		hasDarkBackground,
		context,
		formData,
		topBackgroundColor,
		bottomBackgroundColor,
		itemsOnFirstColumn: parseInt(itemsOnFirstColumn, 10),
		matchStyleToIframeForm,
	};
};
